import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/app/App';
import { initStore } from 'src/app/store';
import 'src/styles/global.css';
import config from 'devextreme/core/config';
import { licenseKey } from 'src/devextreme-license';

// Configure DevExtreme License Key
config({
  licenseKey: licenseKey,
});

// Global init
const store = initStore();
// const store = initStore(__USE_MOCK_DATA__ ? {} : undefined);
// Load React
const rootDOMElement = document.getElementById('app') as HTMLElement;
const root = createRoot(rootDOMElement);

const render = (AppComponent = App) => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <AppComponent />
      </BrowserRouter>
    </Provider>,
  );
};

render(App);

if ((module as any).hot) {
  (module as any).hot.accept(['./app/App'], () => {
    const NextApp = require('./app/App').default;
    render(NextApp);
  });
}

console.info(
  `App started. __ENVIRONMENT__ is ${__ENVIRONMENT__}, __VERSION__ is ${__VERSION__}, NODE_ENV is ${process.env.NODE_ENV}, MOCK MODE IS ${__USE_MOCK_DATA__}`,
);
